export function setToken(data) {
    localStorage.setItem('tykoon_access', JSON.stringify(data.data.accessToken));
    localStorage.setItem('tykoon_refresh', JSON.stringify(data.data.refreshToken));
}

export function removeToken() {
    localStorage.removeItem('tykoon_access');
    localStorage.removeItem('tykoon_refresh');
}